export const fakeFilters = [
  {
    items: [
      {id: 3, value: 'Heart Failure'},
      {id: 4, value: 'Hypertension'},
      {id: 5, value: 'Atrial Fibrillation'},
    ],
    key: 'subspecialty_id',
    label: 'Topics',
  },
];

export const fakeTabs = [
  {
    id: 1,
    tab_name: 'Latest Updates',
    tab_value: 'latest_updates',
    rank: 1,
    hasspecialty: true,
    has_articles: true,
  },
  {
    id: 5,
    tab_name: 'Media',
    tab_value: 'media',
    rank: 6,
    hasspecialty: true,
    has_articles: true,
  },
  {
    id: 9,
    tab_name: 'Congresses',
    tab_value: 'congress',
    rank: 2,
    hasspecialty: true,
    has_articles: true,
  },
  {
    id: 3,
    tab_name: 'Reviews',
    tab_value: 'reviews',
    rank: 4,
    hasspecialty: true,
    has_articles: true,
  },
  {
    id: 6,
    tab_name: 'Case Report',
    tab_value: 'case_report',
    rank: 8,
    hasspecialty: true,
    has_articles: true,
  },
];
